import React from "react";
import { useJobModal } from "../context/JobModalContext";

export default function FinalCTA() {
  const { openJobModal } = useJobModal();
  return (
    <section id="post" className="bg-[#fdfaf7]">
      <div className="max-w-7xl mx-auto px-5 pb-20">
        <div className="rounded-3xl bg-[#7c2233] px-8 py-14 sm:px-14 sm:py-16 text-center relative overflow-hidden">
          <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-white/[0.06]" />
          <div className="absolute -bottom-20 -left-10 w-64 h-64 rounded-full bg-white/[0.05]" />
          <div className="relative">
            <h2 className="font-display text-3xl sm:text-[2.6rem] leading-tight text-white">Ready to find the right care?</h2>
            <p className="text-[16px] text-white/80 mt-4 max-w-2xl mx-auto leading-relaxed">
              Post your job for free and connect with experienced, interviewed and background-checked candidates across the United States.
            </p>
            <a href="#" onClick={(e) => { e.preventDefault(); openJobModal({}); }} className="inline-flex mt-8 items-center justify-center rounded-xl bg-white text-[#7c2233] font-semibold px-8 py-3.5 shadow-lg hover:bg-[#f7e4e6] transition-colors">
              Post a job free
            </a>
            <p className="text-[13px] text-white/70 mt-4">1 month free, then $15.99/month. Cancel anytime.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
